// extracted by mini-css-extract-plugin
module.exports = {"section":"n_4qIy","fullHeight":"_JcRxU","accent":"_i5MF_","neutral":"_8pZKt","separator":"RU3pSe"};